import { render, staticRenderFns } from "./CreateConfigurationModal.vue?vue&type=template&id=55390842&"
import script from "./CreateConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./CreateConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports